import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {ActivatedRoute, ParamMap} from '@angular/router';

interface ObjectType {
  value: string;
  displayName: string;
}

@Component({
  selector: 'app-object',
  templateUrl: './object.component.html',
  styleUrls: ['./object.component.scss']
})
export class ObjectComponent implements OnInit {

  objectTypeOptions: ObjectType[] = [
    {value: 'Grundstück', displayName: 'Grundstück'},
    {value: 'Mehrfamilienhaus', displayName: 'Mehrfamilienhaus'},
    {value: 'Gewerbeimmobilie', displayName: 'Gewerbeimmobilie'},
    {value: 'Doppelhaushälfte', displayName: 'Doppelhaushälfte'},
    {value: 'Einfamilienhaus', displayName: 'Einfamilienhaus'},
    {value: 'Eigentumswohnung', displayName: 'Eigentumswohnung'},
    {value: '2-Familienhaus', displayName: '2-Familienhaus'},
    {value: 'Wohn- und Geschäftshaus', displayName: 'Wohn- und Geschäftshaus'},
    {value: 'Reihenhaus', displayName: 'Reihenhaus'}
  ];
  modernizationStateOptions: ObjectType[] = [
    {value: 'einfach', displayName: 'Einfach'},
    {value: 'mittel', displayName: 'Mittel'},
    {value: 'hoch', displayName: 'Hoch'}
  ];

  objectTypeSelectedValue = '';
  modernizationStateSelectedValue = '';

  @Input()
  formSubmitAttempted: boolean;

  street: string;
  streetNumber: string;
  city: string;

  zipCodeFormControl = new FormControl('', Validators.pattern('.{5}'));
  landSizeFormControl = new FormControl('', Validators.pattern('^[0-9]*'));
  constructionYearFormControl = new FormControl('', Validators.pattern('[0-9]{4}'));
  completeLivingSpaceFormControl = new FormControl('', [Validators.pattern('^[0-9\.]*')]);

  @Output()
  onValidChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private route: ActivatedRoute) {
    this.route.queryParamMap.subscribe(p => {
      this.street = p.get('objectStreet');
      this.streetNumber = p.get('objectStreetNumber');
      this.city = p.get('objectCity');
      this.objectTypeSelectedValue = p.get('objectType');
      this.zipCodeFormControl.setValue(p.get('objectZipCode'));
      this.landSizeFormControl.setValue(p.get('objectPlotSize'));
      this.constructionYearFormControl.setValue(p.get('objectConstructionYear'));
      this.completeLivingSpaceFormControl.setValue(p.get('objectLivingSpace'));
    });
  }

  ngOnInit(): void {
    this.zipCodeFormControl.valueChanges.subscribe(this.updateValidChange.bind(this));
    this.landSizeFormControl.valueChanges.subscribe(this.updateValidChange.bind(this));
    this.constructionYearFormControl.valueChanges.subscribe(this.updateValidChange.bind(this));
    this.completeLivingSpaceFormControl.valueChanges.subscribe(this.updateValidChange.bind(this));
    this.updateValidChange();
  }

  updateValidChange() {
    console.log('zipCodeFormControl', this.zipCodeFormControl.valid);
    console.log('landSizeFormControl', this.landSizeFormControl.valid);
    console.log('constructionYearFormControl', this.constructionYearFormControl.valid);
    console.log('completeLivingSpaceFormControl', this.completeLivingSpaceFormControl.valid);
    this.onValidChange.emit(
      this.zipCodeFormControl.valid &&
      this.landSizeFormControl.valid &&
      this.constructionYearFormControl.valid &&
      this.completeLivingSpaceFormControl.valid
    );
  }

}
